class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();

      if (this.hasAttribute("js-discount-display-warning")) {
        const variantId = event.target.dataset.variantId;
        const warningContainers = document.querySelectorAll('.discount-product__warning-container')

        warningContainers.forEach((container) => {
          container.classList.add('hidden')
          container.setAttribute("aria-hidden", true);
        })

        const warning = document.getElementById(
          `discount-warning-${variantId}`
        );

        if (!warning) {
          this.removeCartItem(event);
          return
        }

        warning.classList.remove("hidden");
        warning.removeAttribute("aria-hidden");
      } else {
        this.removeCartItem(event)
      }
    });
  }

  removeCartItem(event) {
    const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
    const lineItem = {
      name: event.target.dataset.name,
      type: event.target.dataset.type,
      price: event.target.dataset.price,
    };

    cartItems.updateQuantity(
      this.dataset.index,
      0,
      document.activeElement.getAttribute("name"),
      event.target.dataset.variantId,
      lineItem
    );
    cartItems.removeItemDatalayer(event);
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));

    const discountUpdateButtons = document.querySelectorAll(
      "[js-discount-update]"
    );

    const discountAddButtons = document.querySelectorAll(
      "[js-discount-add-to-cart]"
    );

    discountAddButtons.forEach((button) => {
      // Limit to only allow product be added once
      let clickLimitReached = false;

      button.addEventListener("click", (event) => {
        if (clickLimitReached) {
          return
        };

        const discountItem = event.target.closest("[js-discount-properties]");
        this.addDiscountItem(discountItem);
        clickLimitReached = true;
      });
    });

    discountUpdateButtons.forEach((button) => {
      let clickLimitReached = false;

      button.addEventListener("click", (event) => {
        if (clickLimitReached) {
          return
        };

        const discountItem = this.querySelector("[js-discount-item]");
        const updatedDiscountItem = event.target.closest(
          "[js-discount-properties]"
        );

        const updateDiscount = () => {
          this.addDiscountItem(updatedDiscountItem);
        };

        this.removeDiscountItem(discountItem, updateDiscount, true);

        clickLimitReached = true;
      });
    });

    // Remove discount item if change affects threshold
    const removeDiscountItems = this.querySelectorAll(
      "[js-discount-remove-item]"
    );

    removeDiscountItems.forEach((item) => {
      this.removeDiscountItem(item, null, true);
    });
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        this.bloomreachCartEvents(event.cartData, event.action, event.itemDetails)
        return;
      }

      this.bloomreachTrackEvent(event.cartData)
      this.onCartUpdate();
    });
  }

  addToCart(quantity, name, variantId, itemDetails, properties) {
    const body = JSON.stringify({
      items: [
        {
          quantity,
          id: variantId,
          properties,
        },
      ],
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(routes.cart_add_url, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
          action: name,
          itemDetails,
        });
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      });
  }

  addDiscountItem(discountItem) {
    const lineItem = {
      name: discountItem.dataset.name,
      type: discountItem.dataset.type,
      price: discountItem.dataset.price,
    };

    const properties = {
      _discount_product: discountItem.dataset.discount,
      _colour: discountItem.dataset.colour,
    };

    this.addToCart(
      1,
      "add",
      discountItem.dataset.variantId,
      lineItem,
      properties
    );
  }

  removeDiscountItem(discountItem, callback = null, enableUpdate = false) {
    const discountLineItem = {
      name: discountItem.dataset.name,
      type: discountItem.dataset.type,
      price: discountItem.dataset.price,
    };

    // Function to prevent loop when called in updateQuantity
    if (enableUpdate) {
      this.updateQuantity(
        discountItem.dataset.index,
        0,
        "minus",
        discountItem.dataset.variantId,
        discountLineItem,
        callback
      );
    }
  }

  bloomreachCartEvents(data, cartAction, itemDetails) {
    let cartItems = [];

    data.items.forEach((item) => {
      cartItems.push({'product_id': item.product_id, 'variant_id': item.variant_id, 'quantity': item.quantity});
    })
  }

  bloomreachTrackEvent(product) {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    fetch(`/cart.js?no-cache=${new Date().getTime()}`, config)
      .then((response) => response.json())
      .then((response) => this.bloomreachAddToCart(product, response))
      .catch((error) => {
        throw new Error(error);
      });
  }

  bloomreachAddToCart(product, cart) {
    let cartItems = [];

    cart.items.forEach((item) => {
      cartItems.push({'product_id': item.product_id, 'variant_id': item.variant_id, 'quantity': item.quantity});
    })
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    const lineItem = {
      name: event.target.dataset.name,
      type: event.target.dataset.type,
      price: event.target.dataset.price,
    }

    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId, lineItem);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId, itemDetails, callback) {
    this.enableLoading(line);

    let updates = {
      [Number(variantId)]: Number(quantity)
    }

    if (variantId.includes(':')) {
      updates = {
        [variantId.split(':')[0]]: Number(quantity),
        [variantId.split(':')[1]]: Number(quantity)
      }
    }

    const body = JSON.stringify({
      updates,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(routes.cart_update_url, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId, action: name, itemDetails});
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);

        // Remove discount item if change affects threshold
        const removeDiscountItems = this.querySelectorAll(
          "[js-discount-remove-item]"
        );

        removeDiscountItems.forEach((item) => {
          this.removeDiscountItem(item);
        });

        if (callback) {
          callback();
        }
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  removeItemDatalayer(event) {
    const target = event.target;
    const item = target?.closest('[js-cart-drawer="cartItem"]');
    const data = item?.dataset.cartItemData;
    const dataObject = JSON.parse(data);

    gtag("event", "remove_from_cart", {
      currency: window.store.baseCurrency,
      items: dataObject
    });

    // Leaving console log for testing as we have permission issues with GTM
    console.log('remove_from_cart::', dataObject)
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

class DiscountForm extends HTMLElement {
  constructor() {
    super();

    const discountProductSwatches = document.querySelectorAll(
      "[js-discount-swatch]"
    );

    discountProductSwatches.forEach((swatch) => {
      swatch.addEventListener("click", () => {
        const productId = swatch.getAttribute("popovertarget");
        this.handleDiscountDrawerToggle(productId);
      });
    });

    const variantInputs = this.querySelectorAll('input[name="variant"]');

    variantInputs.forEach((input) => {
      input.addEventListener("click", (event) => {
        const optionValue = this.querySelector(".option-value");
        const variantId = this.querySelector('input[name="id"]');
        const discountProperties = this.querySelector(
          "[js-discount-properties]"
        );

        optionValue.innerHTML = event.target.dataset.name;
        variantId.value = event.target.value;
        discountProperties.setAttribute("data-variant-id", event.target.value);
      });
    });
  }

  handleDiscountDrawerToggle(productId) {
    if (productId) {
      document
        .querySelectorAll(".discount-product__drawer")
        .forEach((drawer) => {
          if (drawer.id != productId) {
            drawer.hidePopover();
          }
        });
    }
  }
}

customElements.define("discount-form", DiscountForm);
